import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './hocs/PrivateRoute';
import AuthRoute from './hocs/AuthRoute';

import NotFound from './components/NotFound';
import SignIn from './containers/SignIn';
import CheckEmail from './containers/CheckEmail';
import EmailSignIn from './containers/EmailSignIn';
import TokenSignIn from './containers/TokenSignIn';
import EmailSignInError from './containers/EmailSignInError';

import CompaniesList from './containers/super/CompaniesList';
import CompanyEdit from './containers/super/CompanyEdit';
import PackageEdit from './containers/super/PackageEdit';
import Mailhooks from './containers/super/MailHooks';
import Content from './containers/super/Content';
import LanguageEdit from './containers/super/LanguageEdit';
import Notifications from './containers/super/Notifications';
import NotificationTargets from './containers/super/NotificationTargets';
import Languages from './containers/super/Languages';
import LanguageView from './containers/super/LanguageView';
import CompanyView from './containers/super/CompanyView';
import SettingsOverview from './containers/super/SettingsOverview';
import CompanyPPVLogView from './containers/super/CompanyPPVLogView';
import CompanyPPVTransactionsView from './containers/super/CompanyPPVTransactionsView';
import PartnerEdit from './containers/super/PartnerEdit';
import PartnerView from './containers/super/PartnerView';
import PartnersList from './containers/super/PartnersList';
import FreemiumList from './containers/super/FreemiumList';
import SubscriptionList from './containers/super/SubscriptionList';
import Payments from './containers/super/Payments';
import VideosList from './containers/super/VideosList';
import Cache from './containers/super/Cache';
import Schedule from './containers/super/Schedule';
import UsersList from './containers/super/UsersList';
import Builds from './containers/super/builds';
import Stats from './containers/super/Stats';
import TrialPlan from './containers/super/trialplan';
import ScheduledTasksList from './containers/super/ScheduledTasksList';
import ServiceTasksList from './containers/super/ServiceTasksList';
import ScheduledTask from './containers/super/ScheduledTask';
import ServiceTask from './containers/super/ServiceTask';
import Integrations from './containers/Integrations';
import Admins from './containers/super/admins';
import SystemSettings from './containers/super/SystemSettings';
import AuditLog from './containers/super/AuditLog';
import Gri from './containers/super/Gri';
import LanguagesEditor from './containers/super/LanguagesEditor';
import { observer } from 'mobx-react';

function MainRoutes() {
    return (
        <Routes>
            <Route path="/" element={<PrivateRoute><CompaniesList /></PrivateRoute>} />
            <Route path="/builds" element={<PrivateRoute><Builds /></PrivateRoute>} />
            <Route path="/admins" element={<PrivateRoute><Admins /></PrivateRoute>} />
            <Route path="/companies" element={<PrivateRoute><CompaniesList /></PrivateRoute>} />
            <Route path="/companies/create" element={<PrivateRoute><CompanyEdit /></PrivateRoute>} />
            <Route path="/companies/settings" element={<PrivateRoute><SettingsOverview /></PrivateRoute>} />
            <Route path="/companies/:companyId" element={<PrivateRoute><CompanyView /></PrivateRoute>} />
            <Route path="/companies/:companyId/ppv_log" element={<PrivateRoute><CompanyPPVLogView /></PrivateRoute>} />
            <Route path="/companies/:companyId/ppv_transactions" element={<PrivateRoute><CompanyPPVTransactionsView /></PrivateRoute>} />
            <Route path="/companies/:companyId/edit" element={<PrivateRoute><CompanyEdit /></PrivateRoute>} />
            <Route path="/companies/:companyId/editPackage/:packageId" element={<PrivateRoute><PackageEdit /></PrivateRoute>} />
            <Route path="/mailhooks" element={<PrivateRoute><Mailhooks /></PrivateRoute>} />
            <Route path="/integrations" element={<PrivateRoute><Integrations /></PrivateRoute>} />
            <Route path="/content/*" element={<PrivateRoute><Content /></PrivateRoute>} />
            <Route path="/gri" element={<PrivateRoute><Gri /></PrivateRoute>} />
            <Route path="/stats" element={<PrivateRoute><Stats /></PrivateRoute>} />
            <Route path="/system/settings" element={<PrivateRoute><SystemSettings /></PrivateRoute>} />
            <Route path="/audit" element={<PrivateRoute><AuditLog /></PrivateRoute>} />
            <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
            <Route path="/notifications/:reasonId" element={<PrivateRoute><NotificationTargets /></PrivateRoute>} />
            <Route path="/languages" element={<PrivateRoute><Languages /></PrivateRoute>} />
            <Route path="/languages/editor" element={<PrivateRoute><LanguagesEditor /></PrivateRoute>} />
            <Route path="/languages/create" element={<PrivateRoute><LanguageEdit /></PrivateRoute>} />
            <Route path="/languages/:languageId" element={<PrivateRoute><LanguageView /></PrivateRoute>} />
            <Route path="/languages/:languageId/edit" element={<PrivateRoute><LanguageEdit /></PrivateRoute>} />
            <Route path="/partners/create" element={<PrivateRoute><PartnerEdit /></PrivateRoute>} />
            <Route path="/partners/:partnerId/edit" element={<PrivateRoute><PartnerEdit /></PrivateRoute>} />
            <Route path="/partners/:partnerId/companies" element={<PrivateRoute><CompaniesList /></PrivateRoute>} />
            <Route path="/partners/:partnerId/companies/:companyId" element={<PrivateRoute><CompanyView /></PrivateRoute>} />
            <Route path="/partners/:partnerId" element={<PrivateRoute><PartnerView /></PrivateRoute>} />
            <Route path="/partners" element={<PrivateRoute><PartnersList /></PrivateRoute>} />
            <Route path="/scheduledTasks/:scheduledTaskId/edit" element={<PrivateRoute><ScheduledTask /></PrivateRoute>} />
            <Route path="/scheduledTasks/create" element={<PrivateRoute><ScheduledTask /></PrivateRoute>} />
            <Route path="/scheduledTasks" element={<PrivateRoute><ScheduledTasksList /></PrivateRoute>} />
            <Route path="/serviceTasks/create" element={<PrivateRoute><ServiceTask /></PrivateRoute>} />
            <Route path="/serviceTasks/:serviceTaskId/edit" element={<PrivateRoute><ServiceTask /></PrivateRoute>} />
            <Route path="/serviceTasks" element={<PrivateRoute><ServiceTasksList /></PrivateRoute>} />
            <Route path="/freemium" element={<PrivateRoute><FreemiumList /></PrivateRoute>} />
            <Route path="/subscriptions" element={<PrivateRoute><SubscriptionList /></PrivateRoute>} />
            <Route path="/payments" element={<PrivateRoute><Payments /></PrivateRoute>} />
            <Route path="/videos/:tags" element={<PrivateRoute><VideosList /></PrivateRoute>} />
            <Route path="/cache" element={<PrivateRoute><Cache /></PrivateRoute>} />
            <Route path="/trial" element={<PrivateRoute><TrialPlan /></PrivateRoute>} />
            <Route path="/trainings" element={<PrivateRoute><Schedule /></PrivateRoute>} />
            <Route path="/users" element={<PrivateRoute><UsersList /></PrivateRoute>} />


            <Route path="/auth/email/signin/:token" element={<EmailSignIn />} />
            <Route path="/auth/jwt/signin/:token" element={<TokenSignIn />} />

            <Route path="/auth/signin" element={<AuthRoute><SignIn /></AuthRoute>} />
            <Route path="/auth/check-email" element={<AuthRoute><CheckEmail /></AuthRoute>} />
            <Route path="/auth/error/email" element={<EmailSignInError />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default observer(MainRoutes);
